import * as React from "react";
import type { SVGProps } from "react";
const SvgCheckboxIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={12}
    fill="none"
    {...props}
  >
    <path
      fill="#fff"
      fillRule="evenodd"
      d="M15.39.566a1.043 1.043 0 0 1 0 1.476L6 11.433a1.043 1.043 0 0 1-1.477 0L.61 7.52a1.043 1.043 0 1 1 1.476-1.475L5.261 9.22 13.915.566a1.043 1.043 0 0 1 1.475 0"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgCheckboxIcon;
